module.exports = __webpack_public_path__ + "static/media/os.f4c3f636.png";